import { formatIntacctDate } from '@sit/client-shared';
import { stringWithFallback } from '@web/helpers/label';
import { TableCell, TableRow } from 'carbon-react/lib/components/table';
import Typography from 'carbon-react/lib/components/typography';
import { parseISO } from 'date-fns';
import { useId } from 'react';
import { TimesheetBulkDeleteItem } from '../TimesheetModalContext';

interface TimesheetListItemProps {
  timesheet: TimesheetBulkDeleteItem;
  dateFormat: string;
}

export const TimesheetListItem = ({ timesheet, dateFormat }: TimesheetListItemProps) => {
  const tableId = useId();
  const { startDate: startDateString, endDate: endDateString, id, description } = timesheet;

  // Just in case the dates are strings (they should be Date objects)
  const startDate = typeof startDateString === 'string' ? parseISO(startDateString) : startDateString;
  const endDate = typeof endDateString === 'string' ? parseISO(endDateString) : endDateString;

  return (
    <TableRow id={`${tableId}-${id}`} key={id}>
      <TableCell>
        <Typography mb={0}>{formatIntacctDate(startDate, dateFormat)}</Typography>
      </TableCell>
      <TableCell>
        <Typography mb={0}>{formatIntacctDate(endDate, dateFormat)}</Typography>
      </TableCell>
      <TableCell>
        <Typography mb={0}>{stringWithFallback(description)}</Typography>
      </TableCell>
    </TableRow>
  );
};
